import { SET_TEMPLATES, SET_CONNECTED_TEMPLATES, SET_REGIONS_PER_PROVIDER, SET_SIZES, SNACKBAR, ERROR_SNACKBAR, SET_PRIVATE_TEMPLATES, REMOVE_TEMPLATE_FROM_LIST, SET_CONNECTED_TEMP_DETAILS, SET_SHARED_WITH } from '../mutation-types';
import ApiService from '../../services/api.service';
import asyncWrapper from '../../utils/asyncWrapper';

const state = {
  templates: [],
  connectedTemplates: [],
  privateTemplates: [],
  regionsPerProvider: [],
  connectedTemplateDetails: [],
  sharedTemplateWith: [],
  sizes: []
}

const getters = {
  templates(state) {
    return state.templates;
  },
  connectedTemplates(state) {
    return state.connectedTemplates
  },
  privateTemplates(state) {
    return state.privateTemplates;
  },
  regionsPerProvider(state) {
    return state.regionsPerProvider
  },
  sizes(state) {
    return state.sizes;
  },
  connectedTemplateDetails: state => {
    return state.connectedTemplateDetails
  },
  sharedTemplateWith: state => {
    return state.sharedTemplateWith
  },
}

const actions = {
  async getTemplates({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('templates'));
    

    !error ? commit(SET_TEMPLATES, result) : commit(ERROR_SNACKBAR, 'Unable to get templates');
  },
  async getConnectedTemplates({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('templates/connected'));

    !error ? commit(SET_CONNECTED_TEMPLATES, result) : commit(ERROR_SNACKBAR, 'Unable to get connected templates');
  },
  async getSharedTemplateWith({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`templates/sharedWith/${id}`));

    !error ? commit(SET_SHARED_WITH, result) : commit(ERROR_SNACKBAR, 'Unable to get shared users');
  },
  async getConnectedTemplateDetails({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`templates/connected/details/${id}`));

    !error ? commit(SET_CONNECTED_TEMP_DETAILS, result) : commit(ERROR_SNACKBAR, 'Unable to get template');

    return { error, result }
  },
  async getUserTemplates({ commit }) {
    const { error, result } = await asyncWrapper(ApiService.get('templates/user'));

    !error ? commit(SET_PRIVATE_TEMPLATES, result) : commit(ERROR_SNACKBAR, 'Unable to get private templates');
  },
  async getTemplateRegionInfo({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`templates/regions/${id}`));

    !error ? commit(SET_REGIONS_PER_PROVIDER, result) : commit(ERROR_SNACKBAR, 'Unable to get template regions');

    return { error, result }
  },
  async getConnectedTemplateRegionInfo({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`templates/connected/regions/${id}`));

    !error ? commit(SET_REGIONS_PER_PROVIDER, result) : commit(ERROR_SNACKBAR, 'Unable to get template regions');

    return { error, result }
  },
  async getTemplateVmSizes({ commit }, id) {
    const { error, result } = await asyncWrapper(ApiService.get(`templates/sizes/${id}`));

    !error ? commit(SET_SIZES, result) : commit(ERROR_SNACKBAR, 'Unable to get vm sizes');
  },
  async shareTemplate({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('templates/share', data));

    !error ? commit(SNACKBAR, 'Template successfully shared!') : commit(ERROR_SNACKBAR, 'Unable to share template');
  },
  async shareConnectedTemplate({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('templates/connected/share', data));

    !error ? commit(SNACKBAR, 'Template successfully shared!') : commit(ERROR_SNACKBAR, 'Unable to share template');
  },
  async stopSharingConnectedTemplate({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('templates/connected/stopshare', data));

    !error ? commit(SNACKBAR, 'Sharing stopped') : commit(ERROR_SNACKBAR, 'Stop sharing failed');
  },
  async stopSharingTemplate({ commit }, data) {
    const { error, result } = await asyncWrapper(ApiService.post('templates/stopshare', data));

    !error ? commit(SNACKBAR, 'Sharing stopped') : commit(ERROR_SNACKBAR, 'Stop sharing failed');
  },
  async publishUnpublishTemplate({ commit }, data) {

    const { error, result } = await asyncWrapper(ApiService.put(`templates/${data.templateId}/publication`, data));

    if (!error) {
      commit(REMOVE_TEMPLATE_FROM_LIST, { id: data.templateId, action: data.action })
      commit(SNACKBAR, `Template has been ${data.action}ed successfully!`)
    } else {
      commit(ERROR_SNACKBAR, 'Action failed')
    }
  },
  async deleteTemplate({ commit, dispatch }, id) {
    const { error, result } = await asyncWrapper(ApiService.delete(`vm/templates/${id}`));

    if (!error) {
      commit(SNACKBAR, 'Template has been deleted successfully!')
    }
    else {
      commit(ERROR_SNACKBAR, 'Unable to delete template')
    }
    await dispatch('getUserTemplates');
  }
}

const mutations = {
  [SET_TEMPLATES](state, payload) {
    state.templates = payload;
  },
  [SET_CONNECTED_TEMPLATES](state, payload) {
    state.connectedTemplates = payload;
  },
  [SET_PRIVATE_TEMPLATES](state, payload) {
    state.privateTemplates = payload;
  },
  [SET_REGIONS_PER_PROVIDER](state, payload) {
    state.regionsPerProvider = payload;
  },
  [SET_SIZES](state, payload) {
    state.sizes = payload;
  },
  [SET_CONNECTED_TEMP_DETAILS](state, payload) {
    state.connectedTemplateDetails = payload;
  },
  [SET_SHARED_WITH](state, payload) {
    state.sharedTemplateWith = payload;
  },
  [REMOVE_TEMPLATE_FROM_LIST](state, payload) {
    const { action, id } = payload

    if (action === 'delete') {
      state.privateTemplates = state.privateTemplates.filter(template => template.Id !== id)
    } else {
      state.privateTemplates = state.privateTemplates.map(template => {
        if (template.Id === id) {
          template.IsPublic = action === 'publish' ? true : false
        }

        return template
      })
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}